import React, { useState } from "react";
import { FaChevronLeft, FaChevronRight, FaCalendarDay } from "react-icons/fa";

const TaskCalendarView = ({ tasks, onEdit, onCreateWithDate }) => {
  const [currentDate, setCurrentDate] = useState(new Date());

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];

  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  // Navigation handlers
  const prevMonth = () => {
    setCurrentDate(new Date(year, month - 1, 1));
  };

  const nextMonth = () => {
    setCurrentDate(new Date(year, month + 1, 1));
  };

  const goToToday = () => {
    setCurrentDate(new Date());
  };

  // Calendar calculations
  const firstDayIndex = new Date(year, month, 1).getDay();
  const totalDaysInMonth = new Date(year, month + 1, 0).getDate();
  const totalDaysInPrevMonth = new Date(year, month, 0).getDate();

  // Tasks map by date string YYYY-MM-DD
  const tasksByDate = {};
  tasks.forEach((t) => {
    if (t.due_date) {
      const d = t.due_date.substring(0, 10);
      if (!tasksByDate[d]) tasksByDate[d] = [];
      tasksByDate[d].push(t);
    }
  });

  const calendarCells = [];

  // Previous month trailing days
  for (let i = firstDayIndex - 1; i >= 0; i--) {
    const dayNum = totalDaysInPrevMonth - i;
    calendarCells.push({
      dayNumber: dayNum,
      isCurrentMonth: false,
      dateString: null,
    });
  }

  // Current month days
  const today = new Date();
  const isThisMonth = today.getFullYear() === year && today.getMonth() === month;

  for (let day = 1; day <= totalDaysInMonth; day++) {
    const formattedMonth = String(month + 1).padStart(2, "0");
    const formattedDay = String(day).padStart(2, "0");
    const dateString = `${year}-${formattedMonth}-${formattedDay}`;

    calendarCells.push({
      dayNumber: day,
      isCurrentMonth: true,
      isToday: isThisMonth && today.getDate() === day,
      dateString: dateString,
      tasks: tasksByDate[dateString] || [],
    });
  }

  // Next month leading days to complete grid (42 cells max)
  const remainingCells = 42 - calendarCells.length;
  for (let i = 1; i <= remainingCells; i++) {
    calendarCells.push({
      dayNumber: i,
      isCurrentMonth: false,
      dateString: null,
    });
  }

  return (
    <div className="tm-calendar-container">
      {/* Calendar Header with Navigation */}
      <div className="tm-cal-header">
        <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 700, color: "#1e293b" }}>
          {monthNames[month]} {year}
        </h3>

        <div className="tm-cal-nav">
          <button
            className="tm-btn tm-btn-secondary"
            onClick={goToToday}
            style={{ padding: "6px 12px", fontSize: "12px" }}
          >
            <FaCalendarDay /> Today
          </button>
          <button
            className="tm-btn tm-btn-secondary"
            onClick={prevMonth}
            style={{ padding: "6px 10px" }}
          >
            <FaChevronLeft />
          </button>
          <button
            className="tm-btn tm-btn-secondary"
            onClick={nextMonth}
            style={{ padding: "6px 10px" }}
          >
            <FaChevronRight />
          </button>
        </div>
      </div>

      {/* Days of Week Header */}
      <div className="tm-cal-grid" style={{ marginBottom: "6px" }}>
        {daysOfWeek.map((day) => (
          <div key={day} className="tm-cal-day-name">
            {day}
          </div>
        ))}
      </div>

      {/* Calendar Grid Cells */}
      <div className="tm-cal-grid">
        {calendarCells.map((cell, idx) => (
          <div
            key={idx}
            className={`tm-cal-cell ${!cell.isCurrentMonth ? "other-month" : ""} ${
              cell.isToday ? "today" : ""
            }`}
            onClick={() => {
              if (cell.isCurrentMonth && onCreateWithDate) {
                onCreateWithDate(cell.dateString);
              }
            }}
          >
            <div className="tm-cal-date-num">{cell.dayNumber}</div>

            <div style={{ flex: 1, overflowY: "auto", maxHeight: "80px" }}>
              {cell.tasks &&
                cell.tasks.map((task) => (
                  <div
                    key={task.id}
                    className="tm-cal-task-item"
                    title={`${task.title} (${task.priority})`}
                    onClick={(e) => {
                      e.stopPropagation();
                      onEdit(task);
                    }}
                  >
                    {task.title}
                  </div>
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TaskCalendarView;
